const user = {
    state: {
        status: 'init',
        data: null,
        userInfo: null, // 用户详细信息
        balance: '0.00' // 用户余额
    },
    mutations: {
        setLogin(state, data) {
            state.status = 'logined';
            state.data = data;
            return true;
        },
        setLogout(state) {
            state.status = 'logout';
            state.data = null;
            state.userInfo = null;
            state.balance = '0.00';
        },
        // 设置用户信息
        setUserInfo(state, userInfo) {
            state.userInfo = userInfo;
            // 同时更新余额
            if (userInfo && userInfo.money) {
                state.balance = userInfo.money;
            }
        },
        // 更新用户余额
        updateBalance(state, balance) {
            state.balance = balance;
            // 同时更新用户信息中的余额
            if (state.userInfo) {
                state.userInfo.money = balance;
            }
        }
    },
    getters: {
        // 获取用户余额
        getUserBalance: state => state.balance,
        // 获取用户信息
        getUserInfo: state => state.userInfo,
        // 检查是否已登录
        isLoggedIn: state => state.status === 'logined'
    }
}

export default user
